//@ts-nocheck
// src/components/common/Input/Input.tsx
import React from 'react';
import { InputProps } from '../../../types/common';

export const Input: React.FC<InputProps> = ({
  label,
  id,
  error,
  type = "text",
  className = "",
  required,
  ...props
}) => {
  
  return (
    <div>
      {label && (
        <label 
          htmlFor={id} 
          className="wg-label capitalize inline-flex shrink-0 items-center gap-1 text-[13px] md:text-[14px] lg:text-[14px] text-[#2f2f31] wg-antialiased leading-4 md:leading-5 lg:leading-5 font-medium"
        >
          {label} 
          {required === 'required' && (
            <span className="text-red-500 ml-1">*</span>
          )}
        </label>
      )}
      <div className="mt-1 md:mt-2 lg:mt-2">
        <input
          id={id}
          type={type}
          className={`
            block w-full rounded-md bg-white px-3 py-2 relative
            text-[14px] text-gray-900 
            outline outline-0 -outline-offset-2
            ${error ? 'outline-red-500 focus:ring-0 border-red-500' : 'border-[#d1d5db] outline-gray-300'}
            placeholder:text-gray-400
            focus:outline focus:outline-2 focus:-outline-offset-2 
            ${error ? 'focus:outline-red-500 focus:ring-0' : 'input_hover'}
            sm:text-sm/6
            ${className}
          `}
          {...props}
        />
      </div>
      {error && (
        <p className="mt-1 text-sm text-red-500">
          {error}
        </p>
      )}
    </div>
  );
};